var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgChevronDown(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 9,
    viewBox: "0 0 14 9",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.56386 8.31106L0.166377 1.52225C0.0595781 1.40898 0 1.25848 0 1.10198C0 0.945487 0.0595781 0.794995 0.166377 0.68172L0.173606 0.674411C0.22538 0.619307 0.2877 0.575429 0.356775 0.545446C0.42585 0.515462 0.500235 0.5 0.575407 0.5C0.650578 0.5 0.724963 0.515462 0.794038 0.545446C0.863113 0.575429 0.925433 0.619307 0.977207 0.674411L7.0012 7.06732L13.0228 0.674411C13.0746 0.619307 13.1369 0.575429 13.206 0.545446C13.275 0.515462 13.3494 0.5 13.4246 0.5C13.4998 0.5 13.5741 0.515462 13.6432 0.545446C13.7123 0.575429 13.7746 0.619307 13.8264 0.674411L13.8336 0.68172C13.9404 0.794995 14 0.945487 14 1.10198C14 1.25848 13.9404 1.40898 13.8336 1.52225L7.43614 8.31106C7.37988 8.37077 7.31221 8.4183 7.23724 8.45078C7.16227 8.48325 7.08156 8.5 7 8.5C6.91844 8.5 6.83773 8.48325 6.76276 8.45078C6.68779 8.4183 6.62012 8.37077 6.56386 8.31106Z",
    fill: "#CFCFCF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronDown);
export default __webpack_public_path__ + "static/media/chevron-down.1a4f6276.svg";
export { ForwardRef as ReactComponent };